import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';
import type { API } from '@trinity/chat';

type QuantAnalysis = API.ProjectsQuantAnalysis.QuantAnalysis;
type QuantAnalysisItem = API.ProjectsQuantAnalysis.QuantAnalysisItem;
type QuantVersion = API.ProjectsQuantAnalysis.QuantVersion;
type QuantAnalysisFilter = API.ProjectsQuantAnalysis.QuantAnalysisFilter;


export const QuantAnalysisContext = createContext<QuantAnalysis | null>(null);
export const SelectedQuantAnalysisItemContext = createContext<number | null>(null);
export const SetSelectedQuantAnalysisItemContext = createContext<Dispatch<SetStateAction<number>> | null>(null);
export const QuantAnalysisLoadingContext = createContext<boolean | null>(null);
export const QuantAnalysisItemsContext = createContext<QuantAnalysisItem[] | null>(null);
export const QuantAnalysisVersionsContext = createContext<QuantVersion[] | null>(null);
export const QuantAnalysisVersionContext = createContext<QuantVersion | null>(null);
export const QuantAnalysisFilterContext = createContext<[QuantAnalysisFilter, Dispatch<SetStateAction<QuantAnalysisFilter>>] | null>(null);
export const FolderCreationModeContext = createContext<boolean | null>(false);
export const SetFolderCreationModeContext = createContext<Dispatch<SetStateAction<boolean>> | null>(null);
